// extracted by mini-css-extract-plugin
export default {"additionalInfo":"contactUsSupportingCopy_additionalInfo__DtkpO"};